import React from 'react';

const Layout = ({ children }) => <div className="page-content h-screen">{children}</div>;

export default Layout;
